import React from 'react'
import {
    InlineContentTypes,
    InlineWestLiveBanner,
} from '../SharedPublication.routing'
import { ArticlePublication } from '@news-mono/web-common'
import { LazyTheWestLiveInArticleBanner } from '../../../content/TheWestLive/TheWestLiveInArticleBanner/TheWestInArticleBanner.lazy'

export interface GetInlinePositionedImageLinkProps {
    publication: ArticlePublication
    inlinePublicationContent: InlineContentTypes[]
}

export function isInlineWestLiveBanner(
    content: InlineContentTypes,
): content is InlineWestLiveBanner {
    return content.kind === 'the-west-live-in-article-banner'
}

export function getInlinePositionedWestLiveBanner({
    publication,
    inlinePublicationContent,
}: GetInlinePositionedImageLinkProps) {
    if (publication.kind !== 'article') {
        return []
    }

    return inlinePublicationContent
        .filter(isInlineWestLiveBanner)
        .map((content) => {
            const mappedContent = {
                position: content.insertAfter,
                element: <LazyTheWestLiveInArticleBanner />,
            }
            return mappedContent
        })
}
